import { CURRENCY_CODE, getDataFromStore } from "./CookiesUtils";

let currency = getDataFromStore(CURRENCY_CODE);

export const isEmpty = (val) => {
    if (!val || val === null || val === undefined || val === '' || val <= 0) {
        return true;
    }
    return false;
};

export const getFormattedAmount = (pAmount) => {
    if (!pAmount || pAmount === null || pAmount === undefined || pAmount === '') {
        return "0.00";
    }
    return "" + parseFloat(pAmount).toFixed(2);
}
export const getFormattedAmountN = (pAmount) => {
    let formatter;
    try {
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 2,
        });
    } catch (e) {
        console.warn(`Invalid currency code "${currency}", defaulting to USD.`);
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        });
    }
    return formatter.format(pAmount).replace(/(\D)(\d)/, '$1 $2') || 0.00;
}
export const getFormattedAmountWithDenominationGamePlay = (pAmount, pDenomination) => {
    let formatter;
    try {
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 0,
        });
    } catch (e) {
        console.warn(`Invalid currency code "${currency}", defaulting to USD.`);
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        });
    }
    let calc = pAmount / pDenomination;
    return formatter.format(calc).replace(/(\D)(\d)/, '$1 $2');
}
export const getFormattedAmountWithDenominationGamePlayBy100 = (pAmount, pDenomination) => {
    let formatter;
    try {
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: currency,
            minimumFractionDigits: 2,
        });
    } catch (e) {
        console.warn(`Invalid currency code "${currency}", defaulting to USD.`);
        formatter = new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        });
    }
    let calc = (pAmount / pDenomination) / 100;
    return formatter.format(calc).replace(/(\D)(\d)/, '$1 $2') || 0.00;
}


export const getFormattedAmountWithDenomination = (pAmount, pDenomination) => {
    let calc = pAmount / pDenomination;
    return Math.ceil(calc);
}
// export const isNumeric = (str) => {
//     if (typeof str != 'string') {
//         return false; // we only process strings!
//     }
//     return (
//         !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
//         !isNaN(parseFloat(str))
//     ); // ...and ensure strings of whitespace fail
// };
// export const getImageSrc = (imgSrc) => {
//     if (this.isEmpty(imgSrc)) {
//         // if imgSrc is empty then set default image.
//         return '/assets/images/001/user.png';
//     }
//     return imgSrc;
// };
// export const isMobile = (mobile) => {
//     const regEx = /^[6-9]\d{9}$/;
//     return regEx.test(mobile);
// };
// export const isEmail = (email) => {
//     const regEx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
//     return regEx.test(email);
// };
// export const isUpiId = (upiId) => {
//     const regEx = /[a-zA-Z0-9.\\-_]{2,256}@[a-zA-Z]{2,64}/;
//     return regEx.test(upiId);
// };

// export const getDOB = value => {
//     if (typeof value === "number" || value.toString().split("") === 1) {
//         return dateUtilities.formattedDate(value, "yyyy-MM-dd")
//     }
//     return value
// }

// export const getTimeFromDate = value => {
//     return new Date(value).getTime()
// }

// export const isValidIsdCode = (isdCode) => {
//     const regEx = /^\+\d{1,3}$/;
//     return regEx.test(isdCode);
// }

export const isValidJsonString = (jsonString) => {
    try {
        JSON.parse(jsonString);
    } catch (e) {
        return false;
    }
    return true;
}

/**
 * Gets the currency symbol from a currency code
 * @param {string} currencyCode - The ISO 4217 currency code (e.g., 'USD', 'BRL', 'EUR')
 * @returns {string} The currency symbol (e.g., '$', 'R$', '€')
 */
export const getCurrencySymbol = (currencyCode = currency) => {
    try {
        // Create a formatter using the currency code
        const formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currencyCode,
            minimumFractionDigits: 0,
        });
        
        // Format 0 and extract just the symbol
        const symbol = formatter.format(0).replace(/[0-9.,\s]/g, '');
        return symbol;
    } catch (e) {
        console.warn(`Invalid currency code "${currencyCode}", defaulting to $.`);
        return '$';
    }
};